import { createContext, useContext, useState } from 'react'
import ModalInfo from 'presentation/components/ui/modal-info/modal-info'

const ModalInfoContext = createContext(null)

export const ModalInfoProvider = ({ children }) => {
  const [visible, setVisible] = useState<boolean>()
  const [content, setContent] = useState<any>({
    title: 'titulo',
    subTitle: 'sub titulo',
    description: 'description'
  })

  const close = () => {
    setVisible(false)
  }

  const showModal = (body) => {
    setContent(body)
    setVisible(true)
  }

  return (
    <ModalInfoContext.Provider value={{ visible, close, showModal }}>
      <ModalInfo visible={visible} close={close} content={content} />
      {children}
    </ModalInfoContext.Provider>
  )
}

export const useModalinfo = () => {
  const context = useContext(ModalInfoContext)

  if (!context) throw new Error('Necessário utilizar o ModalInfoProvider')

  return (
    { ...context }
  )
}
